import { dark } from './dark'
import { chalk } from './chalk'
import { glass } from './glass'
import { blue } from './blue'
export const Themes = {
  dark,
  chalk,
  glass,
  blue
}
